import React, {useState} from 'react';

import {Navigate} from "react-router-dom";
import {UsePermissions} from "../../hooks/usePermissions";
import {TableCliente} from "./components/TableCliente";
import {ModalNuevoCliente} from "./components/ModalNuevoCliente";
import {ModalEditarCliente} from "./components/ModalEditarCliente";


export const ClientePage = () => {
    const [permisos] = UsePermissions();
    const [displayNewModal, setDisplayNewModal] = useState(false);
    const [displayeditModal, setDisplayeditModal] = useState(false);
    const [fieldEdit, setFieldEdit] = useState({});
    const [reload, setReload] = useState(false);

    const editarUsuario= (e) => {
        setFieldEdit({...e});
        setDisplayeditModal(true);
    }

    const crearnuevoUsuario = () => {
        setDisplayNewModal(true);
    }

    const onHide = () => {
        setDisplayNewModal(false);
        setReload(true);
        resetLoad();
    }
    const onHideEdit = () => {
        setDisplayeditModal(false);
        setReload(true);
        resetLoad()
    }

    const resetLoad = () => {
        setTimeout(() =>{
            setReload(false);
        }, 2000)
    }

    return (
        <>
            <div className="container-relative">
                {permisos.consultar ? <TableCliente reload={reload} obtenerParametrosUser={editarUsuario} nuevoUsuario={crearnuevoUsuario}/> : <Navigate to="/home"/>}
                <ModalNuevoCliente show={displayNewModal} hide={onHide}/>
                <ModalEditarCliente show={displayeditModal} hide={onHideEdit} fields={fieldEdit} />
            </div>
        </>
    );
};

